/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

// import Vue from 'vue';
import store from '@/store';
import {
  CHECK,
  LOGIN,
  LOGOUT,
  UPDATEBROKERCUSTOMERS,
  ADDBROKERCUSTOMER,
  PROFILESAVE,
  UPDATEVERIFIED,
  UPDATEFAV,
  SETUSERINFO,
} from './mutation-types';

export default {
  [CHECK](state) {
    state.authenticated = !!localStorage.getItem('access_token');
    if (localStorage.getItem('is_broker'))
      state.isBroker = localStorage.getItem('is_broker') === 'true';
    if (localStorage.getItem('is_internal'))
      state.isInternal = localStorage.getItem('is_internal') === 'true';
    if (localStorage.getItem('is_verified'))
      state.isVerified = localStorage.getItem('is_verified') === 'true';
    if (localStorage.getItem('name'))
      state.name = localStorage.getItem('name');
    if (localStorage.getItem('id'))
      state.id = localStorage.getItem('id');
    if (localStorage.getItem('phone'))
      state.phone = localStorage.getItem('phone');
    if (localStorage.getItem('country_code'))
      state.countryCode = localStorage.getItem('country_code');
    if (localStorage.getItem('permissions') !== 'undefined' && localStorage.getItem('permissions'))
      state.permissions = JSON.parse(localStorage.getItem('permissions'));
    if (localStorage.getItem('bd_uploaded_projects') !== 'undefined' && localStorage.getItem('bd_uploaded_projects'))
      state.projects = JSON.parse(localStorage.getItem('bd_uploaded_projects'));
    if (localStorage.getItem('broker_customers_data') !== 'undefined' && localStorage.getItem('broker_customers_data'))
      state.brokerCustomersData = JSON.parse(localStorage.getItem('broker_customers_data')).payload;
    if (localStorage.getItem('fbid') !== 'undefined' && localStorage.getItem('fbid'))
      state.fbid = localStorage.getItem('fbid');
    if (localStorage.getItem('googleProfileImage') !== 'undefined' && localStorage.getItem('googleProfileImage'))
      state.googleProfileImage = localStorage.getItem('googleProfileImage');
  },

  [LOGIN](state, payload) {
    state.authenticated = true;
    state.isInternal = !!payload.permissions;
    state.brokerCustomersData = payload.broker_customers_data;
    state.permissions = payload.permissions;
    state.bdUploadedProjects = payload.bd_uploaded_projects;
    state.id = payload.id;
    localStorage.setItem('permissions', JSON.stringify(payload.permissions));
    localStorage.setItem('bd_uploaded_projects', JSON.stringify(payload.bd_uploaded_projects));
    localStorage.setItem('access_token', payload.access_token);
    localStorage.setItem('is_internal', !!payload.permissions);
    localStorage.setItem('broker_customers_data', JSON.stringify({ payload: payload.broker_customers_data }));
    if (payload.project_id)
      localStorage.setItem('open_project_id', payload.project_id);
    if (payload.bid_amount)
      localStorage.setItem('open_bid_amount', payload.bid_amount);
    if (payload.dev_id)
      localStorage.setItem('dev_id', payload.dev_id);
    // check for Referral Code of broker
    if (payload.referral_code)
      localStorage.setItem('referral_code', payload.referral_code);
    if (payload.company_name)
      localStorage.setItem('company_name', payload.company_name);
    if (payload.rera_no)
      localStorage.setItem('rera_no', payload.rera_no);
    localStorage.setItem('id', payload.id);
    store.dispatch('socket/disconnect');
  },

  [LOGOUT](state) {
    state.authenticated = false;
    state.isBroker = false;
    state.isInternal = false;
    store.state.home.projectDetails = null;
    state.name = null;
    state.phone = null;
    state.id = null;
    state.bdUploadedProjects = null;
    state.favHomeProject = [];
    localStorage.removeItem('access_token');
    localStorage.removeItem('is_broker');
    localStorage.removeItem('is_internal');
    localStorage.removeItem('broker_customers_data');
    localStorage.removeItem('permissions');
    localStorage.removeItem('name');
    localStorage.removeItem('phone');
    localStorage.removeItem('id');
    localStorage.removeItem('dev_id');
    localStorage.removeItem('fav_home_project');
    if (localStorage.getItem('open_project_id')) localStorage.removeItem('open_project_id');
    if (localStorage.getItem('open_bid_amount')) localStorage.removeItem('open_bid_amount');
    if (localStorage.getItem('referral_code')) localStorage.removeItem('referral_code');
    store.dispatch('account/resetToDefaultState');
    store.dispatch('home/resetToDefaultState');
    store.dispatch('broker/resetToDefaultState');
    store.dispatch('socket/disconnect');
  },

  [UPDATEBROKERCUSTOMERS](state, payload) {
    const objIndex = state.brokerCustomersData.findIndex((
      obj => String(obj.id) === String(payload.id)));
    state.brokerCustomersData[objIndex].customer_name = payload.customer_name;
    localStorage.setItem('broker_customers_data', JSON.stringify({ payload: state.brokerCustomersData }));
  },

  [ADDBROKERCUSTOMER](state, payload) {
    state.brokerCustomersData.push(payload);
    localStorage.setItem('broker_customers_data', JSON.stringify({ payload: state.brokerCustomersData }));
  },

  [PROFILESAVE](state, payload) {
    if (payload.name) {
      state.name = payload.name;
      localStorage.setItem('name', payload.name);
    }
    if (payload.phone) {
      state.phone = payload.phone;
      localStorage.setItem('phone', payload.phone);
    }
    if (payload.id) {
      state.fbid = payload.id;
      localStorage.setItem('fbid', payload.id);
    }
    if (payload.googleProfileImage) {
      state.googleProfileImage = payload.googleProfileImage;
      localStorage.setItem('googleProfileImage', payload.googleProfileImage);
    }
  },
  [UPDATEVERIFIED](state, payload) {
    state.isVerified = payload.isVerified;
    localStorage.setItem('is_verified', payload.isVerified);
  },
  [UPDATEFAV](state, payload) {
    state.favHomeProject = payload;
    localStorage.setItem('fav_home_project', JSON.stringify(state.favHomeProject));
  },
  [SETUSERINFO](state, payload) {
    state.isVerified = payload.is_phone_verified;
    state.isBroker = payload.is_broker;
    state.phone = payload.phone;
    state.countryCode = payload.ph_country_code;
    state.favHomeProject = payload.favourite_projects;
    localStorage.setItem('fav_home_project', JSON.stringify(payload.favourite_projects));
    localStorage.setItem('is_broker', payload.is_broker);
    localStorage.setItem('is_verified', payload.is_phone_verified);
    localStorage.setItem('country_code', payload.ph_country_code);
    localStorage.setItem('phone', payload.phone);
    if (payload.name) {
      state.name = payload.name;
      localStorage.setItem('name', payload.name);
    }
    if (payload.dev_id)
      localStorage.setItem('dev_id', payload.dev_id);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js